import React from 'react';

// The start window every one-tap deep dive shows (#2163, founder pick A
// 2026-09-28): a tap opens it, the read starts on its own when the bar fills
// (DIVE_GRACE_MS, utils/startingPicture), and Cancel is the honest way out
// until then. ONE component so /welcome and the first-read bar (#2359) can
// never drift apart in what they promise or how long they wait.
//
// `compact` is the bar's size: buttons side by side at every width.
// `testIdPrefix` keeps /welcome's shipped test ids (deep-dive-*).
const StartingWindow = React.forwardRef(function StartingWindow(
    { pick, onStartNow, onCancel, compact = false, className = '', testIdPrefix = 'deep-dive', ...rest },
    ref,
) {
    return (
        <div
            ref={ref}
            tabIndex={-1}
            role="status"
            data-testid={`${testIdPrefix}-starting`}
            className={`rounded-2xl border-2 border-[#1A4D2E] bg-white ${compact ? 'p-4' : 'p-5'} focus:outline-none focus-visible:ring-2 focus-visible:ring-[#1A4D2E]/50 ${className}`}
            {...rest}
        >
            <p className={`font-serif font-semibold text-[#2C2C2C] ${compact ? 'text-lg' : 'text-xl'}`}>
                Starting your deep dive on {pick.university_name}
            </p>
            <p className="mt-1.5 text-sm text-[#4A4A4A] leading-relaxed">
                Your fit score and gaps, your chances major by major, a strategy,
                and essay angles. About a minute.
            </p>
            <div className="mt-3 h-1 rounded-full bg-[#E8F0E9] overflow-hidden" aria-hidden="true">
                {/* Keyed on the school so switching schools restarts the fill.
                    Reduced motion: no animation, the bar simply shows full. */}
                <div key={pick.university_id}
                     data-testid={`${testIdPrefix}-grace-bar`}
                     className="h-full w-0 bg-[#1A4D2E] motion-safe:animate-dive-grace motion-reduce:w-full" />
            </div>
            <div className={`mt-4 flex gap-2.5 ${compact ? '' : 'flex-col sm:flex-row'}`}>
                <button
                    type="button"
                    data-testid={`${testIdPrefix}-go`}
                    onClick={onStartNow}
                    className={`${compact ? 'flex-1 sm:flex-none' : ''} rounded-xl bg-[#1A4D2E] px-6 py-3 text-sm font-semibold text-white hover:bg-[#2D6B45]`}
                >
                    Start now
                </button>
                <button
                    type="button"
                    data-testid={`${testIdPrefix}-cancel`}
                    onClick={onCancel}
                    className={`${compact ? 'flex-1 sm:flex-none' : ''} rounded-xl border border-[#E0DED8] px-6 py-3 text-sm font-medium text-[#4A4A4A] hover:border-[#1A4D2E]`}
                >
                    Cancel
                </button>
            </div>
        </div>
    );
});

export default StartingWindow;
